import React from 'react';
import { IconService } from './IconService';
export const IconComponent = ({ iconName, className }) => {
	return IconService(iconName, className);
};
